/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { SITEMETA_DATA } from "../../../data/siteMeta.data"


function SEO({ page, description, lang, meta, title, additionalSchema }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || (page && SITEMETA_DATA[page].description) || site.siteMetadata.description;
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://apexx.global#organization",
    "name": "APEXX Global",
    "legalName": "APEXX Fintech Limited",
    "url": "https://apexx.global/",
    "logo": "https://apexx.global/static/4fb98955b0c4c8b17a0a77af65307c2f/14b42/apexx-logo.jpg",
    "email": "sales@apexx.global",
    "foundingDate": "2015",
    "vatID": "259056289",
    "slogan": "A Single Integration to APEXX gives you the flexibility to route transactions via the best-performing payment service providers.",
    "knowsAbout": "Payment Orchestration",
    "sameAs": [
      "https://www.linkedin.com/company/apexxglobal/"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "sales",
      "email": "sales@apexx.global"
    },
    "address": [
      {
        "@type": "PostalAddress",
        "streetAddress": "69 Turnmill St",
        "addressLocality": "London",
        "postalCode": "EC1M 5RR",
        "addressCountry": "United Kingdom"
      },
      {
        "@type": "PostalAddress",
        "streetAddress": "Office No. 212, 2nd floor, Urbanwrks",
        "addressLocality": "Bund Garden, Sangamvadi",
        "postalCode": "Pune-411004",
        "addressCountry": "India"
      },
      {
        "@type": "PostalAddress",
        "streetAddress": "36/5, Hustlehub Tech Park, First Building, 2nd Floor",
        "addressLocality": "Haralukunte Village, Bengaluru",
        "postalCode": "Karnataka 560102",
        "addressCountry": "India"
      },
      {
        "@type": "PostalAddress",
        "streetAddress": "One World Trade Center",
        "addressLocality": "New York",
        "postalCode": "10007",
        "addressCountry": "United States"
      }
    ],
    "founder": [
      {
        "@type": "Person",
        "name": "Rodney Bain",
        "jobTitle": "President, USA & Co-Founder",
        "sameAs": "https://www.linkedin.com/in/rodney-bain-b3b6264b/"
      },
      {
        "@type": "Person",
        "name": "Peter Keenan",
        "jobTitle": "CEO & Co-Founder",
        "sameAs": "https://www.linkedin.com/in/peter-keenan-aca-london/"
      },
      {
        "@type": "Person",
        "name": "Toreson Lloyd",
        "jobTitle": "CCO & Co-Founder",
        "sameAs": "https://www.linkedin.com/in/toresonlloyd/"
      }
    ]
  };
  
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title || SITEMETA_DATA[page].title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      {additionalSchema ? (
      <script type="application/ld+json">
        {JSON.stringify(additionalSchema)}
      </script>
      ) : null}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
